import { render, staticRenderFns } from "./CbsJsonEditor.vue?vue&type=template&id=2b490770&scoped=true"
import script from "./CbsJsonEditor.vue?vue&type=script&lang=js"
export * from "./CbsJsonEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b490770",
  null
  
)

export default component.exports